import React from 'react'
import { ThreatIndicatorsCategory } from 'app/modules/reports/types'
import { IndicatorTypeItem } from './indicator-type'

export interface CategoryListProps {
  categories: string[]
  filteredIndicators: ThreatIndicatorsCategory[]
  openCategories: string[]
  openTypes: string[]
  selectedTypes: string[]
  selectedIndicators: string[]
  onOpenCategory: (category: string) => void
  onOpenAccordion: (type: string) => void
  onSelectType: (type: string) => void
  onSelectIndicator: (indicator: string) => void
}

export const CategoryList: React.FC<Readonly<CategoryListProps>> = ({
  categories,
  filteredIndicators,
  openCategories,
  openTypes,
  selectedTypes,
  selectedIndicators,
  onOpenCategory,
  onOpenAccordion,
  onSelectType,
  onSelectIndicator,
}) => (
  <div className="indicators-list-wrapper">
    {categories.length > 0 && (
      <div className="indicators-list-categories">
        {categories.map((category) => (
          <CategoryItem
            key={category}
            category={category}
            isOpen={openCategories.includes(category)}
            onOpenCategory={onOpenCategory}
            filteredIndicators={filteredIndicators.filter((type) => type.category === category)}
            openTypes={openTypes}
            selectedTypes={selectedTypes}
            selectedIndicators={selectedIndicators}
            onOpenAccordion={onOpenAccordion}
            onSelectType={onSelectType}
            onSelectIndicator={onSelectIndicator}
          />
        ))}
      </div>
    )}
  </div>
)

export interface CategoryItemProps {
  category: string
  isOpen: boolean
  onOpenCategory: (category: string) => void
  filteredIndicators: ThreatIndicatorsCategory[]
  openTypes: string[]
  selectedTypes: string[]
  selectedIndicators: string[]
  onOpenAccordion: (type: string) => void
  onSelectType: (type: string) => void
  onSelectIndicator: (indicator: string) => void
}

export const CategoryItem: React.FC<Readonly<CategoryItemProps>> = ({
  category,
  isOpen,
  onOpenCategory,
  filteredIndicators,
  openTypes,
  selectedTypes,
  selectedIndicators,
  onOpenAccordion,
  onSelectType,
  onSelectIndicator,
}) => {
  const totalGroups = filteredIndicators.reduce((acc, curr) => acc + curr.groups.length, 0)

  return (
    <div className="indicators-list-element d-block">
      <div className="indicator-category-accordion-title" onClick={() => onOpenCategory(category)}>
        <span className="text-m text-muted">
          {category} ({totalGroups})
        </span>
        <div className="d-flex flex-grow-1 justify-content-end pe-2">
          <i className={`ds3-icon ${isOpen ? 'ds3-solid-down' : 'ds3-solid-right'}`} />
        </div>
      </div>
      <div className={isOpen ? '' : 'd-none'}>
        {filteredIndicators.length > 0 &&
          filteredIndicators.map((type) => (
            <IndicatorTypeItem
              key={type.type}
              type={type}
              isOpen={openTypes.includes(type.type)}
              isSelected={selectedTypes.includes(type.type)}
              selectedIndicators={selectedIndicators}
              onOpenAccordion={onOpenAccordion}
              onSelectType={onSelectType}
              onSelectIndicator={onSelectIndicator}
            />
          ))}
      </div>
    </div>
  )
}
